import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import MainDrawer from "components/drawer/MainDrawer";
import ApkUploadDrawer from "components/drawer/ApkUploadDrawer";
import DeleteModal from "components/modal/DeleteModal";
import EditDeleteButton from "components/table/EditDeleteButton";
import useToggleDrawer from "hooks/useToggleDrawer";
import React from "react";
import { notifySuccess } from "utils/toast";

const ApkUploadTable = ({
  apkList,
  perpage,
  currentPage,
  hideDelete,
  hideEdit,
}) => {
  const { title, serviceId, handleUpdate, isSubmitting } = useToggleDrawer();

  return (
    <>
      <DeleteModal id={serviceId} title={title} />
      <MainDrawer>
        <ApkUploadDrawer id={serviceId} />
      </MainDrawer>
      <TableBody>
        {apkList?.slice(0, perpage).map((apk, index) => (
          <TableRow key={apk.id}>
            <TableCell className="text-center text-xs">{index + 1}</TableCell>
            <TableCell className="text-center text-xs">{apk.version}</TableCell>
            <TableCell className="text-center text-xs">
              <span title={apk.release_notes} className="cursor-pointer">
                {apk.release_notes && apk.release_notes.length > 25
                  ? apk.release_notes.substring(0, 25) + "..."
                  : apk.release_notes}
              </span>
            </TableCell>

            <TableCell className="text-center text-xs">
              {apk.type === 1
                ? "Vendor App"
                : apk.type === 2
                ? "Executive App"
                : apk.type === 3
                ? "Franchise App"
                : "Unknown Type"}
            </TableCell>
            <TableCell className="text-center text-xs">
              {apk.is_mandatory ? "Yes" : "No"}
            </TableCell>

            <TableCell className="text-center text-xs">
              {apk.download_url ? (
                <button
                  onClick={() => {
                    const fullUrl = `${process.env.REACT_APP_API_IMAGE_URL}${apk.download_url}`;
                    navigator.clipboard.writeText(fullUrl);
                    notifySuccess("Link copied!");
                  }}
                  className="text-blue-600 hover:underline"
                >
                  Copy
                </button>
              ) : (
                "-"
              )}
            </TableCell>

            <TableCell>
              <div className="flex justify-center">
                <EditDeleteButton
                  id={apk.id}
                  title={apk.version}
                  isSubmitting={isSubmitting}
                  handleUpdate={() =>
                    handleUpdate(apk.id, null, null, apk.version)
                  }
                  hideEdit={hideEdit}
                  //   hideDelete={true}
                />
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default ApkUploadTable;
